import {
  Block_List_FieldsFragmentDoc,
  useInsert_Block_TagMutation,
} from '@geerd-nx/shareable-graphql';

export function useCreateBlockTag(blockQuiz: number) {
  const [mutate] = useInsert_Block_TagMutation({
    update: (cache, { data }) => {
      cache.updateFragment(
        {
          fragment: Block_List_FieldsFragmentDoc,
          id: `block_list_item:${blockQuiz}`,
        },
        (prev) => {
          return {
            ...prev,
            block_tags: [
              ...(prev?.block_tags ?? []),
              ...(data?.insert_block_tag?.returning ?? []),
            ],
          };
        }
      );
    },
  });
  return mutate;
}
